import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  return (
    <div className="flex1 justify-center">
      <div className="flex1 flex-col items-center">
      
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
          
<p>
<strong> Welcome to the DES Key Generation Simulator! This interactive module is designed to guide you through the entire process of round key generation in the Data Encryption Standard (DES) algorithm. By following the steps provided, you will gain a deep understanding of how keys are generated for each of the 16 rounds in DES. <br /><br /></strong>
    
    → Begin by entering an eight-character string in the provided input box. This will be your DES Key . Once entered, click on the “Start” button to convert this string into a 64-bit binary form. <br /><br />
    
    → Use the “next” and “previous” buttons to move forward or backward through each step of the key generation process. For each round, observe the changes and transformations that take place. <br /><br />
    
    → The binary data will be represented as a matrix. This format makes it easier to follow the transformations and calculations.<br/><br/>

    → As you navigate through the rounds, the simulator will display calculations for the round keys from 1 to k-1. Once you reach the kth round, you will be prompted to calculate the key for this round based on what you've learned. <br /><br />
    
    → If your calculation for the kth round key is correct, the simulator will proceed to display the rest of the rounds. If the calculation is incorrect, you will receive feedback. Use this as an opportunity to revisit previous rounds and understand where you might have made an error. <br /><br />
    
    → At any point, if you wish to restart the simulation from the beginning or rewatch a specific portion, click on the “PREVIOUS” button.  <br /><br />

    → To Complete this Experiment the student has to identify the Final 48 bit Key Generated<br /><br />
    
    <strong> While the simulator provides a visual understanding, it's a recommended to keep a notebook handy. Note down observations, patterns, or questions you might have. Remember, the aim of this simulator is not just to teach you the process, but to give you a deep understanding of DES key generation. <br /><br /></strong>
    
  
  </p>


        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
